import { __makeTemplateObject } from "tslib";
import { css, spacing } from '../../../foundation';
export var StepperStyle = function () {
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    padding: ", ";\n  "], ["\n    padding: ", ";\n  "])), spacing(6, 0, 6, 0));
};
var templateObject_1;
